module.exports = __webpack_public_path__ + "static/media/SummaryCh5_A01378565.429d87cc.pdf";